export const SET_ACCOUNT_DETAIL_MODE = "SET_ACCOUNT_DETAIL_MODE";
export const SET_LEADS = "SET_LEADS";
export const SET_POSTS = "SET_POSTS";
